import menu from './zh-TW/menu';
import form from './zh-TW/form';
import validation from './zh-TW/validation';
import table from './zh-TW/table';
import models from './zh-TW/model';
import _enum from './zh-TW/enum';
import pages from './zh-TW/pages';

export default {
  'navBar.lang': '語言',
  'layout.user.link.help': '幫助',
  'layout.user.link.privacy': '隱私',
  'layout.user.link.terms': '條款',
  'app.preview.down.block': '下載此頁面到本地項目',
  'app.welcome.link.fetch-blocks': '獲取所有區塊',
  'app.welcome.link.block-list': '快速建立基於「區塊」開發的標準頁面',
  ...menu,
  ...form,
  ...validation,
  ...table,
  ...models,
  ...pages,
  ..._enum,
};
